import { createFileRoute, redirect } from '@tanstack/react-router'
import { documentQuery } from '@/features/documents/api'
import { DocumentComposer } from '@/features/documents/composer/composer'

export const Route = createFileRoute('/_app/documents/edit/$id')({
  staticData: { crumb: 'Editar borrador' },
  loader: async ({ context, params }) => {
    const doc = await context.queryClient.ensureQueryData(documentQuery(params.id))
    if (doc.status !== 'draft') throw redirect({ to: '/documents/$id', params: { id: doc.id } })
    return doc
  },
  component: EditDraft,
})

function EditDraft() {
  const draft = Route.useLoaderData()
  return <DocumentComposer kind={draft.kind as 'FE'} draft={draft} />
}
